import script from "./ErrorOut.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorOut.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorOut.vue?vue&type=style&index=0&id=781e0141&lang=css"

const __exports__ = script;

export default __exports__